export function formatNumber(
    value: number | string,
    options: Intl.NumberFormatOptions = {}
): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(num)) return '';

    return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2,
        ...options,
    }).format(num);
}
export const capitalizeFirstLetter = (str: string): string => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};
